<template>
  <div class="register-box">
    <div class="register-main">
      <div class="left-box">
        <div class="title-box">
          <div class="left-title">选择您想登录的产品</div>
          <div class="title-english">CHOOSE YOUR PRODUCT</div>
        </div>
        <div class="tabs flex-cen-cen-col">
          <div :class="
            'each-tab flex-cen-cen-col ' +
            (nowindex == 'LK' ? 'active-tab' : '')
          " @click="nowindex = 'LK'">
            <div class="tab-title flex-cen-cen">华南冷库管理系统</div>
            <span class="tips">South China cold storage</span>
          </div>
        </div>
      </div>
      <div class="right-register">
        <div class="erp" v-if="nowindex == 'LK'">
          <div class="title">
            <div id="fullname">登录华南冷库管理系统</div>
          </div>
          <div style="margin-top: 20px; margin: auto" class="title">
            <el-radio-group v-model="nowLKloginType" size="mini">
              <el-radio-button label="账号密码登录"></el-radio-button>
              <el-radio-button label="手机号登录"></el-radio-button>
            </el-radio-group>
          </div>
          <div v-if="nowLKloginType == '账号密码登录'">
            <div class="item" style="margin-top: 30px">
              <div class="label">公司名</div>
              <div class="input">
                <input v-model="LKData.kehu" name="ctl00$ContentPlaceHolder1$txt_companyname" type="text"
                  id="ContentPlaceHolder1_txt_companyname" class="mobile value" placeholder="请输入公司编号或公司全称(必填)" />
              </div>
              <div id="companyname_error" class="js-error" style="display: none"></div>
            </div>
            <div class="item">
              <div class="label">编号</div>
              <div class="input">
                <input v-model="LKData.mNum" name="ctl00$ContentPlaceHolder1$txt_companyname" type="text"
                  id="ContentPlaceHolder1_txt_companyname" class="mobile value" placeholder="请输入操作员编号(必填)" />
              </div>
              <div id="companyname_error" class="js-error" style="display: none"></div>
            </div>
            <div class="item">
              <div class="label">密码</div>
              <div class="input">
                <input v-model="LKData.mPassword" name="ctl00$ContentPlaceHolder1$txt_companyname" type="password"
                  class="mobile value" placeholder="请输入登录密码(必填)" />
              </div>
              <div id="companyname_error" class="js-error" style="display: none"></div>
            </div>
            <router-link style="
                color: blue;
                text-decoration: underline;
                text-align: center;
                width: 100%;
                display: block;
              " :to="{ path: '/reset' }">
              忘记密码?</router-link>
            <div class="btn">
              <div id="btn_Submit" class="button" @click="sendLK()">
                前往登录
              </div>
            </div>
          </div>
          <div v-if="nowLKloginType == '手机号登录'">
            <div class="item" style="margin-top: 30px">
              <div class="label">手机号</div>
              <div class="input">
                <input v-model="LKData.mPhone"  type="text"
                  onkeyup="if(isNaN(value))execCommand('undo')"
                  onafterpaste="if(isNaN(value))execCommand('undo')" onblur="CheckPhone(1);" maxlength="11"
                  class="mobile value" placeholder="请输入手机号(必填)" />
              </div>
              <div id="mobile_error" class="js-error" style="display: none"></div>
            </div>

            <input type="hidden" 
              class="mobile value" placeholder="是否显示" />
            <div class="item">
              <div class="label">验证码</div>
              <div class="input input-position input-sizing">
                <input v-model="LKData.mYzm" @blur="tocheck"  type="text"
       
                   class="text code-value" maxlength="6"
                  placeholder="请输入验证码"  style="width: 100px" />
                <i v-if="isshowCheck" :style="
                  'font-size:18px;color:' +
                  (yzmOK == true ? 'green;' : 'red;')
                " :class="
  yzmOK ? 'el-icon-circle-check' : 'el-icon-circle-close'
"></i>
                <div class="get-code"  v-bind:disabled="issend == true" @click="SendMsM">
                  {{ issend ? "请稍后(" + lastTime + ")秒" : "获取短信验证码" }}
                </div>
              </div>
            </div>
            <div class="btn">
              <div id="btn_Submit" class="button" @click="loginLKByPhone()">
                前往登录
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { saveZixun, sendMsM, checkMsM, getLKUrl, setUsed,getLKUrlAndGetPhoneKey } from "@/api/index";
import Axios from "axios";
export default {
  data() {
    return {
      LKData: {},
      nowindex: "LK",
      isshowCheck:false, issend: false,
      nowLKloginType: "账号密码登录",
    };
  },
  methods: {
    loginLKByPhone(){

    },
     tocheck() {
      const params = new URLSearchParams();
      params.append("phone", this.LKData.mPhone);
      params.append("code", this.LKData.mYzm);
      params.append("sign", this.sign);
      checkMsM(params)
        .then((e) => {
          if (e.data == true) {
            this.yzmOK = true;
            this.isshowCheck = true;
          }
        })
        .catch((e) => {
          this.yzmOK = false;
          this.isshowCheck = true;
        });
    },
    SendMsM() {
      var phone = this.LKData.mPhone;
      if (
        phone == undefined ||
        phone == null ||
        this.isPoneAvailable(phone) == false
      ) {
        this.$notify({
          type: "error",
          title: "温馨提示",
          message: "请输入正确的手机号",
          duration: 2000,
          showClose: true,
        });
        return false;
      }
      const params = new URLSearchParams();
      params.append("phone", phone);

      //发送
      sendMsM(params).then((e) => {
        this.sign = e.msg;
        this.$notify({
          type: "success",
          title: "温馨提示",
          message: "发送成功，注意查收",
          duration: 5000,
          showClose: true,
        });
        this.issend = true;
        this.lastTime = 60;
        var int = self.setInterval((e) => {
          this.lastTime = this.lastTime - 1;
          if (this.lastTime == 0) {
            this.issend = false;
            clearTimeout(int);
          }
        }, 1000);
      });
    },    isPoneAvailable($poneInput) {
      var myreg = /^[1][3,4,5,6,7,8,9][0-9]{9}$/;
      if (!myreg.test($poneInput)) {
        return false;
      } else {
        return true;
      }
    },
    sendLK() {
      if (this.LKData.kehu == null || this.LKData.kehu == undefined) {
        this.$notify({
          type: "error",
          title: "温馨提示",
          message: "请填写改公司名",
          duration: 1000,
          showClose: true,
        });
        return;
      }
      if (this.LKData.mNum == null || this.LKData.mNum == undefined) {
        this.$notify({
          type: "error",
          title: "温馨提示",
          message: "请填写登录编号",
          duration: 1000,
          showClose: true,
        });
        return;
      }
      if (this.LKData.mPassword == null || this.LKData.mPassword == undefined) {
        this.$notify({
          type: "error",
          title: "温馨提示",
          message: "请填写密码",
          duration: 1000,
          showClose: true,
        });
        return;
      }

      //校验账号密码
      getLKUrl().then((response) => {
        var loginurl =
          response.msg +
          "/csms/kehuAdmin/doLogin?kehu=" +
          this.LKData.kehu +
          "&m_num=" +
          this.LKData.mNum +
          "&m_password=" +
          this.LKData.mPassword;
        Axios.get(loginurl).then((loginresponse) => {
          if (loginresponse.data.code != 0) {
            this.$notify({
              type: "error",
              title: "温馨提示",
              message: loginresponse.data.msg,
              duration: 1000,
              showClose: true,
            });
            return;
          } else {
            const params = new URLSearchParams();
            params.append("kehu", this.LKData.kehu);
            params.append("mNum", this.LKData.mNum);
            params.append("mPassword", this.LKData.mPassword);

            setUsed(params);

            window.open(
              response.msg +
              `/csms/kehuAdmin/doLoginTest?kehu=${this.LKData.kehu}&m_num=${this.LKData.mNum}&m_password=${this.LKData.mPassword}`
            );
          }
        });
      });
    },
     loginLKByPhone() {
      if (this.LKData.mPhone == null || this.LKData.mPhone == undefined) {
        this.$notify({
          type: "error",
          title: "温馨提示",
          message: "请填写手机号",
          duration: 1000,
          showClose: true,
        });
        return;
      }
      if (this.LKData.mYzm == null || this.LKData.mYzm == undefined) {
        this.$notify({
          type: "error",
          title: "温馨提示",
          message: "请填写验证码",
          duration: 1000,
          showClose: true,
        });
        return;
      }
  const params = new URLSearchParams();
      params.append("phone", this.LKData.mPhone);
      params.append("code", this.LKData.mYzm);
      params.append("sign", this.sign);
      params.append("type", "LK");
      //校验账号密码
      getLKUrlAndGetPhoneKey(params).then((response) => {
        
            window.open( response.msg );
          

      })   .catch((e) => {
       this.$notify({
          type: "error",
          title: "温馨提示",
          message: e,
          duration: 1000,
          showClose: true,
        });
        });;
    },
  },
};
</script>
<style scoped>
body {
  margin: 0;
}

input {
  outline: 0px;
}

input:-webkit-autofill {
  box-shadow: 0 0 0px 1000px #fff inset !important;
}

.register-box {
  background: url(/img/bg.png) no-repeat;
  background-size: 100% 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 560px;
}

.disabled {
  background-color: rgb(160, 160, 160) !important;
}

.register-main {
  display: flex;
  justify-content: space-between;
  align-items: stretch;
  height: 470px;
  width: 710px;
}

.psi {
  display: flex;
  flex: 1;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 50px 0 30px 0;
}

.psi .title {
  font-weight: bold;
  font-size: 20px;
  display: flex;
  justify-content: center;
  margin-bottom: 14px;
  align-items: flex-end;
}

.title div {
  font-family: "SourceHanSansCN-Heavy";
}

.title #productname {
  font-size: 20px;
  font-weight: bold;
  color: #2861d2;
}

.erp {
  display: block;
  flex: 1;
  margin-top: 25px;
  padding: 10px 20px;
}

.input-sizing {
  width: 229px !important;
}

.erp .title {
  font-weight: bold;
  font-size: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 14px;
}

.erp .title #fullname {
  font-size: 20px;
  color: #2861d2;
}

.erp .title a {
  font-weight: bold;
  font-size: 20px;
}

.mini-title {
  font-size: 14px;
  margin-left: 6px;
  color: rgb(118, 118, 118);
}

.right-register {
  flex: 1;
  background-color: #ecf1fd;
  display: flex;
  justify-content: center;
  align-items: stretch;
}

.psi .input {
  width: 240px;
  height: 36px;
  margin-left: 8px;
  box-sizing: border-box;
}

.input {
  /*    padding: 0 6px;*/
  background-color: #fff;
  /*    margin-top: 6px;*/
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  width: 230px;
  /*    padding-right:9px;*/
}

.input .get-code {
  /*        width: 110px;*/
  color: #2962d2;
  font-size: 12px;
  margin-left: 8px;
  padding-right: 6px;
  cursor: pointer;
}

.input input {
  width: 120px;
  padding-left: 6px;
  height: 16px;
  border: 0;
  flex: 1;
  height: 28px;
}

.psi .xieyi {
  padding-left: 110px;
}

.xieyi {
  align-self: stretch;
  display: flex;
  align-items: center;
  font-size: 12px;
}

.xieyi a {
  color: #2962d2;
  font-size: 12px;
  text-decoration: none;
}

.code {
  width: 108px !important;
}

.psi .btn .button {
  height: 30px;
  font-size: 16px;
  padding-left: 30px;
  width: 200px;
}

.btn {
  display: flex;
  justify-content: center;
  justify-self: flex-end;
  margin-top: 20px;
  cursor: pointer;
}

.erp .btn .button {
  height: 28px;
  font-size: 16px;
  width: 200px;
}

.space {
  letter-spacing: 24px;
}

.btn .button {
  width: 150px;
  /*display: flex;
    justify-content: center;*/
  align-items: center;
  color: #fff;
  height: 30px;
  line-height: 30px;
  text-align: center;
  font-size: 14px;
  background-color: #2861d2;
  border: none;
  border-radius: 4px;
}

/*左侧*/
.left-box {
  display: flex;
  flex-direction: column;
  padding: 120px 0 90px 0px;
  box-sizing: border-box;
  align-items: center;
  background: url(/img/left-bg.png) no-repeat;
  background-size: 100% 100%;
  width: 265px;
  justify-content: space-between;
}

.left-title {
  font-size: 16px;
  color: #fff;
  margin-bottom: 6px;
}

.title-english {
  color: #fff;
  display: flex;
  font-size: 12px;
  opacity: 0.2;
  flex-direction: column;
  align-items: flex-start;
}

.flex-cen-cen-col {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}

.flex-cen-cen {
  display: flex;
  justify-content: center;
  align-items: center;
}

.flex-between-center {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.tabs {
  align-self: stretch;
}

.tab-title {
  font-weight: bold;
  font-size: 16px;
}

.each-tab {
  width: 245px;
  height: 50px;
  width: 100%;
  padding: 6px 0;
  cursor: pointer;
  box-sizing: border-box;
  border-top: 1px solid #396dce;
}

.tab-title,
.tips {
  color: #91b8ff;
}

.tips {
  color: #62a2e4;
  font-size: 14px;
}

.active-tab {
  background: url(/img/choosed.png) no-repeat;
  background-size: 100% 100%;
  position: relative;
  width: 102.4%;
  z-index: 100;
  margin-left: 7px;
  padding-right: 7px;
  border-top: 0;
}

.active-tab .tab-title,
.active-tab .tips {
  color: #fff;
}

.none {
  display: none;
}

select {
  width: 200px;
  border: none;
  outline: 0px;
}

option {
  background-color: #fff;
}

a {
  text-decoration: none;
}

.psi menuitem {
  display: flex;
  align-items: center;
  background-color: #fff;
  margin-bottom: 20px;
  padding-left: 6px;
  border-radius: 4px;
  overflow: hidden;
}

.psi .item .label {
  width: 45px;
  text-align: justify;
  text-align-last: justify;
}

.title-line {
  width: 1px;
  height: 20px;
  background-color: #3a3a3a;
  margin-left: 10px;
}

.psi .item {
  /*    background-color:#fff;*/
}

.item {
  display: flex;
  align-items: center;
  /*    background-color: #fff;*/
  margin-bottom: 20px;
  padding-left: 10px;
  justify-content: center;
  border-radius: 4px;
  /*    overflow: hidden;*/
  position: relative;
  height: 45px;
}

.psi .js-error {
  position: absolute;
  top: 42px;
  left: 50px;
  border-radius: 2px;
  color: #f27171;
  font-size: 14px;
  box-sizing: border-box;
}

.erp .item {
  height: 28px;
}

.erp .item input {
  flex: 1;
}

.erp .js-error {
  position: absolute;
  top: 28px;
  left: 10px;
  border-radius: 2px;
  color: #f27171;
  font-size: 12px;
  min-width: 400px;
  text-align: center;
  box-sizing: border-box;
}

.erp .xieyi {
  margin-bottom: 10px;
  padding-left: 90px;
}

input::-webkit-input-placeholder {
  /* WebKit browsers */
  color: rgb(160, 160, 160);
}

.input-position {
  box-sizing: border-box;
  height: 32px;
}

.value:focus {
  outline: 1px solid #1b4eb2;
}

.item .label {
  width: 45px;
  margin-right: 12px;
  text-align: justify;
  text-align-last: justify;
  font-size: 14px;
}

.select-box {
  width: 210px;
  display: flex;
  justify-content: flex-end;
  align-items: center;
}

.select-box img {
  width: 20px;
}

.positon-r {
  position: relative;
}

.list {
  position: absolute;
  border-bottom: -40px;
  left: 100px;
}
</style>